export const CarouselUXLMockJson = {
  search: {
    properties: {
      searchByDestination: {
        edges: [
          {
            node: {
              basicInformation: {
                brand: {
                  code: null,
                  name: 'Outdoor Collection by Marriott Bonvoy',
                  photos: [],
                },
                hasFitness: null,
                hasGolf: null,
                hasRenovatedRooms: false,
                hasSpa: null,
                isAdultsOnly: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                resort: null,
                region: null,
                newProperty: true,
                displayName: null,
                newLobby: false,
                bookable: true,
                name: 'Postcard Cabins Talladega Valley, Outdoor Collection by Marriott Bonvoy',
              },
              media: {
                primaryImage: {
                  edges: [
                    {
                      node: {
                        alternateDescription: 'Exterior, Seating + Fire Pit',
                        title: 'Exterior 8 17676',
                        imageUrls: {
                          wideHorizontal: '/is/image/marriotts7prod/oc-bhmtl-exterior-8-17676:Wide-Hor',
                          square: '/is/image/marriotts7prod/oc-bhmtl-exterior-8-17676:Square',
                          classicVertical: '/is/image/marriotts7prod/oc-bhmtl-exterior-8-17676:Classic-Ver',
                          classicHorizontal: '/is/image/marriotts7prod/oc-bhmtl-exterior-8-17676:Classic-Hor',
                        },
                        caption: 'Exterior, Seating + Fire Pit',
                        isPrimary: true,
                      },
                    },
                  ],
                },
                id: 'BHMTL',
              },
              id: 'BHMTL',
              contactInformation: {
                address: {
                  country: {
                    description: 'USA',
                  },
                },
              },
            },
          },
          {
            node: {
              basicInformation: {
                brand: {
                  code: null,
                  name: 'Outdoor Collection by Marriott Bonvoy',
                  photos: [],
                },
                hasFitness: null,
                hasGolf: null,
                hasRenovatedRooms: false,
                hasSpa: null,
                isAdultsOnly: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                resort: false,
                region: null,
                newProperty: true,
                displayName: null,
                newLobby: false,
                bookable: true,
                name: 'Postcard Cabins Starved Rock',
              },
              media: {
                primaryImage: {
                  edges: [
                    {
                      node: {
                        alternateDescription: 'Fire Pit with chairs',
                        title: 'Fire Pit',
                        imageUrls: {
                          wideHorizontal: '/is/image/marriotts7prod/oc-fire-pit-15291:Wide-Hor',
                          square: '/is/image/marriotts7prod/oc-fire-pit-15291:Square',
                          classicVertical: '/is/image/marriotts7prod/oc-fire-pit-15291:Classic-Ver',
                          classicHorizontal: '/is/image/marriotts7prod/oc-fire-pit-15291:Classic-Hor',
                        },
                        caption: 'Fire Pit',
                        isPrimary: true,
                      },
                    },
                  ],
                },
                id: 'BMIOO',
              },
              id: 'BMIOO',
              contactInformation: {
                address: {
                  country: {
                    description: 'USA',
                  },
                },
              },
            },
          },
          {
            node: {
              basicInformation: {
                brand: {
                  code: null,
                  name: 'Outdoor Collection by Marriott Bonvoy',
                  photos: [],
                },
                hasFitness: null,
                hasGolf: null,
                hasRenovatedRooms: false,
                hasSpa: null,
                isAdultsOnly: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                resort: null,
                region: null,
                newProperty: true,
                displayName: null,
                newLobby: false,
                bookable: true,
                name: 'Postcard Cabins Starved Rock',
              },
              media: {
                primaryImage: {
                  edges: [
                    {
                      node: {
                        alternateDescription: 'Exterior, Picnic Table',
                        title: 'Exterior 2 27112',
                        imageUrls: {
                          wideHorizontal: '/is/image/marriotts7prod/xe-cjsjj-cjsjj-guest-room-sin64536-11859:Wide-Hor',
                          square: '/is/image/marriotts7prod/xe-cjsjj-cjsjj-guest-room-sin64536-11859:Square',
                          classicVertical:
                            '/is/image/marriotts7prod/xe-cjsjj-cjsjj-guest-room-sin64536-11859:Classic-Ver',
                          classicHorizontal:
                            '/is/image/marriotts7prod/xe-cjsjj-cjsjj-guest-room-sin64536-11859:Classic-Hor',
                        },
                        caption: 'Exterior, Picnic Table',
                        isPrimary: true,
                      },
                    },
                  ],
                },
                id: 'BMISR',
              },
              id: 'BMISR',
              contactInformation: {
                address: {
                  country: {
                    description: 'USA',
                  },
                },
              },
            },
          },
          {
            node: {
              basicInformation: {
                brand: {
                  code: null,
                  name: 'Outdoor Collection by Marriott Bonvoy',
                  photos: [],
                },
                hasFitness: null,
                hasGolf: null,
                hasRenovatedRooms: false,
                hasSpa: null,
                isAdultsOnly: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                resort: false,
                region: null,
                newProperty: false,
                displayName: null,
                newLobby: false,
                bookable: true,
                name: 'Trailborn Highlands',
              },
              media: {
                primaryImage: {
                  edges: [
                    {
                      node: {
                        alternateDescription: 'Two chairs facing a wood-burning fireplace',
                        title: 'THNC Main Lobby 21597',
                        imageUrls: {
                          wideHorizontal: '/is/image/marriotts7prod/oc-avlhl-thnc-main-lobby-21597:Wide-Hor',
                          square: '/is/image/marriotts7prod/oc-avlhl-thnc-main-lobby-21597:Square',
                          classicVertical: '/is/image/marriotts7prod/oc-avlhl-thnc-main-lobby-21597:Classic-Ver',
                          classicHorizontal: '/is/image/marriotts7prod/oc-avlhl-thnc-main-lobby-21597:Classic-Hor',
                        },
                        caption: 'Kick back fireside with cozy chairs and good vibes',
                        isPrimary: true,
                      },
                    },
                  ],
                },
                id: 'AVLHL',
              },
              id: 'AVLHL',
              contactInformation: {
                address: {
                  country: {
                    description: 'USA',
                  },
                },
              },
            },
          },
          {
            node: {
              basicInformation: {
                brand: {
                  code: null,
                  name: 'Outdoor Collection by Marriott Bonvoy',
                  photos: [],
                },
                hasFitness: null,
                hasGolf: null,
                hasRenovatedRooms: false,
                hasSpa: null,
                isAdultsOnly: false,
                isFullyRenovated: false,
                isRecentlyRenovated: false,
                resort: false,
                region: null,
                newProperty: true,
                displayName: null,
                newLobby: false,
                bookable: true,
                name: 'OC Growth Test Hotel',
              },
              media: {
                primaryImage: {
                  edges: [
                    {
                      node: {
                        alternateDescription: 'AQAOC_Photo_Primary_Asset',
                        title: 'AQAOC_Photo_Primary_Asset',
                        imageUrls: {
                          wideHorizontal: '/is/image/marriotts7stage/oc-aqaoc-aqaoc-photo-primary-asset-32461:Wide-Hor',
                          square: '/is/image/marriotts7stage/oc-aqaoc-aqaoc-photo-primary-asset-32461:Square',
                          classicVertical:
                            '/is/image/marriotts7stage/oc-aqaoc-aqaoc-photo-primary-asset-32461:Classic-Ver',
                          classicHorizontal:
                            '/is/image/marriotts7stage/oc-aqaoc-aqaoc-photo-primary-asset-32461:Classic-Hor',
                        },
                        caption: 'AQAOC_Photo_Primary_Asset',
                        isPrimary: true,
                      },
                    },
                  ],
                },
                id: 'AQAOC',
              },
              id: 'AQAOC',
              contactInformation: {
                address: {
                  country: {
                    description: 'Antarctica',
                  },
                },
              },
            },
          },
        ],
        total: 5,
      },
    },
  },
};
